<template>
  <div id="app">
    <SideBar v-if="showSidebar" />

    <div :class="[contentClass, currentPageClass]">
      <transition name="fade" mode="out-in">
        <router-view
          @navigateToPlanWithNewTask="handleNavigateToPlanWithNewTask"
        />
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isModalOpen: true,
      formattedCurrentDate: "",
    };
  },
  methods: {
    updateCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      this.formattedCurrentDate = `${year}/${month}/${day}`;
    },
    handleNavigateToPlanWithNewTask() {
      this.$router.push({ name: "PlanList", query: { newTask: true } });
    },
  },
  mounted() {
    this.updateCurrentDate();
  },
  computed: {
    showSidebar() {
      return this.$route.meta.layout !== "EmptyLayout";
    },
    contentClass() {
      return this.showSidebar ? "main-content" : "full-width-content";
    },
    currentPageClass() {
      return this.$route.meta.className || "";
    },
  },
};
</script>

<style>
html body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #f8f8f8;
}

#app {
  display: flex;
  height: 100%;
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 280px;
  height: 100vh;
  z-index: 500;
  transition: width 0.3s;
}

.full-width-content {
  width: 100%;
  max-width: 100%;
  padding: 0;
  position: static;
  top: 0;
  left: 0;
}

.main-content {
  position: fixed;
  top: 10px;
  left: 300px;
  width: 90%;
  max-width: calc(100% - 100px);
}

@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    height: 300px;
  }
  .main-content {
    position: static;
    margin: 1.5rem;
  }
}

@media (max-width: 576px) {
  .sidebar {
    width: 100%;
    height: 300px;
  }

  .main-content {
    padding-top: 260px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
